import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { useRecaptcha } from "../../../hooks/useRecaptcha";

export const useForgotPassword = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();
  const { checkRecaptcha } = useRecaptcha();

  const handleForgotPassword = useCallback(
    (email: string, emailConfirmation: string) => {
      dispatch(appActions.showLoading());

      checkRecaptcha(
        () => {
          dispatch(
            authActions.forgetPassword.started({
              accepted: true,
              email,
              email_confirmation: emailConfirmation,
              // TODO: change to selected language
              lang: "ja",
              onComplete: () => dispatch(appActions.hideLoading()),
              onSuccess: () =>
                navigateToPage(PageRoutes.RESET_PASSWORD_MESSAGE),
            }),
          );
        },
        () => {
          dispatch(appActions.hideLoading());
          navigateToPage(PageRoutes.RESET_PASSWORD_MESSAGE);
        },
      );
    },
    [checkRecaptcha],
  );

  return { handleForgotPassword };
};
